import TablaConciliacion from "../../../TablaConciliacion";

function TablaAutoviaNeivaGirardot() {
  return <TablaConciliacion nombreUseCase="AUTOVIANEIVAGIRARDOT" titulo="AUTOVIA NEIVA-GIRARDOT" />;
}

export default TablaAutoviaNeivaGirardot;
